<template>
  <div class="topActionBar">
    <img :src="photoURL" @click="showProfileColumn()" class="avatarImageTopBar" v-if="$store.state.display.leftColumn.isExpanded && photoURL" />
    <img src="@/assets/images/nophoto.png" @click="showProfileColumn()" class="avatarImageTopBar" v-else-if="$store.state.display.leftColumn.isExpanded && !photoURL" />
    <div class="userName" v-if="$store.state.display.leftColumn.isExpanded">
      {{ $store.state.session.user.VisibleName }}
    </div>

    <div class="spacer" />

    <a @click.prevent="showContactsListColumn()" v-if="$store.state.display.leftColumn.isExpanded">
      <img class="showContactsListBtn" src="@/assets/images/startchat2.png" />
    </a>

    <dropdown :is-icon="false" :class-name="'topBar'" ref="photoDropDown">
      <template slot="btn">
        <a class="menuBtn">
          <img src="@/assets/images/menu.png" v-if="$store.state.display.leftColumn.isExpanded" />
        </a>
      </template>
      <template slot="body">
        <div class="photoMenuItem" @click="logout">
          Çıkış yap
        </div>
        <div class="photoMenuItem" @click="changeLeftColumnType">
          Yıldızlı mesajlar
        </div>
      </template>
    </dropdown>
    <a class="collapseLeftColumnBtn" @click.prevent="toggleLeftColumnWidth()" v-if="$store.state.display.leftColumn.isExpanded">
      <img class="collapseLeftColumnBtnImg" src="@/assets/images/collapse_left.png" />
    </a>
    <a class="expandLeftColumnBtn" @click.prevent="toggleLeftColumnWidth()" v-if="!$store.state.display.leftColumn.isExpanded">
      <img class="expandLeftColumnBtnImg" src="@/assets/images/expand_left.png" />
    </a>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
require('@/security.js')
export default {
  mixins: [messageMixin],
  computed: {
    photoURL() {
      let photoURL = this.$store.state.session.user.PhotoURL

      if (photoURL === undefined || photoURL === null || photoURL === '') {
        return null
      } //'@/assets/images/nophoto.png'
      if (photoURL.includes('http') || photoURL.includes('nophoto.png')) {
        return photoURL
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(photoURL, key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + photoURL + '&s=' + encodeURIComponent(encryptedBody)
      }
    },

    isConnected() {
      return this.$store.state.isConnected
    }
  },
  methods: {
    changeLeftColumnType() {
      this.$store.state.display.leftColumn.starredMessage.isExpanded = true
    },
    toggleLeftColumnWidth() {
      this.$store.state.display.leftColumn.isExpanded = !this.$store.state.display.leftColumn.isExpanded
    },
    showProfileColumn() {
      this.$store.state.display.leftColumn.isExpanded = true
      this.$store.state.display.leftColumn.profile.isExpanded = true
    },
    showContactsListColumn() {
      this.$store.state.display.leftColumn.isExpanded = true
      this.$store.state.display.leftColumn.newConversation.isExpanded = true
    },

    logout() {
      this.$store.state.socket.connection.close()
      this.rlo('ssn')

      // Resetting user-related objects and socket connection
      // this.$store.state.message.messages = []
      // this.$store.state.message.unsentMessages = []
      // this.$store.state.message.currentMessageText = ''
      // this.$store.state.messagestatus.messageStatuses = []
      this.$store.state.conversation.conversations = []
      this.$store.state.conversation.activeConversation = {
        isBuddyWriting: false
      }

      this.$store.state.socket.connection.onclose = null
      this.$store.state.socket.connection.close()
      this.$store.state.socket.connection = null
      this.$store.state.isFirstLoad = true

      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>

<style scoped>
.topActionBar {
  background-color: #eaeceb;
  border-bottom: rgb(223, 223, 223) 1px solid;
  height: 60px;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
}

.noConnection {
  background-color: rgb(223, 100, 100);
}

.spacer {
  flex-grow: 1;
}

.avatarImageTopBar {
  background-color: white;
  border-radius: 50%;
  height: 45px;
  width: 45px;
  margin-left: 10px;
  cursor: pointer;
  object-fit: cover;
}

.offlineImage,
.collapseLeftColumnBtnImg,
.showContactsListBtn,
.expandLeftColumnBtnImg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}

.offlineImage {
  margin-top: -5px;
  cursor: default;
}

.menuBtn > img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}

.expandLeftColumnBtn {
  width: 60px;
  text-align: center;
}

.userName {
  margin-left: 10px;
  color: #000000;
  font-weight: 700;
  font-size: 14px;
}

.photoMenuItem {
  cursor: pointer;
  padding: 5px;
}

.photoMenuItem:hover {
  background-color: #ffbaf2;
}
</style>
